module.exports = __webpack_public_path__ + "img/KE.f2f58407.svg";